import { Component, EventEmitter, OnInit } from '@angular/core';
import { DwButtonConfig, DwModalResult, DwButtonCommand, DwModalHandler, DwModalConfig } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { AdminUserProperties } from '../../models/admin-user-properties.model';
import { FitnessUser } from '../../models/fitness-user.model';

// TODO: Update userTypeLookupId with the actual lookup ID once database metadata is generated.
const USER_TYPE_LOOKUP_ID = 0;

@Component({
  selector: 'app-user-type-selection-modal',
  templateUrl: './user-type-selection-modal.component.html',
  styleUrls: ['./user-type-selection-modal.component.scss']
})
export class UserTypeSelectionModalComponent implements OnInit, DwModalHandler {
  userTypeLookupId = USER_TYPE_LOOKUP_ID;
  adminUserTypeId: any;

  modalConfig: DwModalConfig<FitnessUser>;
  closeModal: EventEmitter<DwModalResult<any>>;
  ngOnDestroy?: () => void;

  constructor() {

  }

  ngOnInit(): void {
    const user = this.modalConfig.data;

    if (user == null) {
      console.error("UserTypeSelectionModalComponent: No user passed in modal data");
      return;
    }

    this.adminUserTypeId = user.UserTypeId;
  }

  buttonClick(buttonConfig: DwButtonConfig): Observable<DwModalResult> {
    const modalResult = new DwModalResult<Partial<AdminUserProperties>>();

    modalResult.closeModal = true;
    modalResult.cancelled = false;
    modalResult.buttonCommand = buttonConfig.command;

    switch (buttonConfig.command) {
      case DwButtonCommand.saveAndClose:

        if (!this.validateForm()) {
          modalResult.closeModal = false;
          return of(modalResult);
        }

        modalResult.cancelled = false;
        modalResult.data = {
          userTypeMode: this.adminUserTypeId,
        };

        return of(modalResult);

      default:
        // Otherwise we're cancelling
        modalResult.cancelled = true;
        return of(modalResult);
    }
  }

  validateForm() {
    return true;
  }
}
